export { default } from "./OrdersPage";



// WEBPACK FOOTER //
// ./src/screens/Orders/index.ts